import * as yup from "yup";

export const validationSchema = yup.object().shape({
  name: yup.string().required("First name is required"),
  email: yup
    .string()
    .required("A valid email address is required")
    .email(),
  question: yup
    .string()
    .required("A question is required")
    .min(5, "A question with a minimum of 5 characters is required")
});
